import { render } from "./ArrowLink.vue?vue&type=template&id=3943ca84&scoped=true"
import script from "./ArrowLink.vue?vue&type=script&lang=js"
export * from "./ArrowLink.vue?vue&type=script&lang=js"

import "./ArrowLink.vue?vue&type=style&index=0&id=3943ca84&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3943ca84"]])

export default __exports__